//Authentication
export const AUTH_USER = 'AUTH_USER';
export const UNAUTH_USER = 'UNAUTH_USER';
export const FETCH_USER_INFO = 'FETCH_USER_INFO';
export const FETCH_USER_INFO_SUCCESS = 'FETCH_USER_INFO_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const SESSION_MODAL = 'SESSION_MODAL';

//Navigation
export const TOGGLE_MOBILE_NAV = 'TOGGLE_MOBILE_NAV';
export const CLOSE_NAV = 'CLOSE_NAV';
export const TOGGLE_EXPAND_NAV = 'TOGGLE_EXPAND_NAV';

//On Site Date
export const ADD_ON_SITE_DATE = 'ADD_ON_SITE_DATE';
export const DELETE_ON_SITE_DATE = 'DELETE_ON_SITE_DATE';
export const SET_ONSITE_DATES = 'SET_ONSITE_DATES';

//Promo Items
export const ADD_PROMO_ITEMS = 'ADD_PROMO_ITEMS';
export const DELETE_PROMO_ITEMS = 'DELETE_PROMO_ITEMS';

//Line Items
export const ADD_LINE_ITEMS = 'ADD_LINE_ITEMS';
export const DELETE_LINE_ITEMS = 'DELETE_LINE_ITEMS';

//Resize
export const RESIZE = 'RESIZE';

//Search
export const TOGGLE_SEARCH = 'TOGGLE_SEARCH';
export const CLOSE_SEARCH = 'CLOSE_SEARCH';
export const RESET_SEARCH_RESULTS = 'RESET_SEARCH_RESULTS';
export const FETCH_SEARCH_RESULTS = 'FETCH_SEARCH_RESULTS';
export const FILTERED_SEARCH_RESULTS = 'FILTERED_SEARCH_RESULTS';
export const UPDATE_DISTRICT_SUCCESS = 'UPDATE_DISTRICT_SUCCESS';
export const UPDATE_RS_SUCCESS = 'UPDATE_RS_SUCCESS';
export const UPDATE_RSS_OSS_SUCCESS = 'UPDATE_RSS_OSS_SUCCESS';

//Alerts
export const PAST_DUE_SUCCESS = 'PAST_DUE_SUCCESS';
export const INCOMPLETE_SUCCESS = 'INCOMPLETE_SUCCESS';
export const NEEDS_REVIEW_SUCCESS = 'NEEDS_REVIEW_SUCCESS';
export const PENDING_APPROVAL_SUCCESS = 'PENDING_APPROVAL_SUCCESS';
export const RETURNED_FOR_EDIT_SUCCESS = 'RETURNED_FOR_EDIT_SUCCESS';
export const REJECTED_EVENTS_SUCCESS = 'REJECTED_EVENTS_SUCCESS';
export const ALERTS_LOADING = 'ALERTS_LOADING';
export const SET_NEW_TASKS_VISITED = 'SET_NEW_TASKS_VISITED';
export const BADGE_COUNT_SUCCESS = 'BADGE_COUNT_SUCCESS';

//Dashboard
export const FETCH_DASHBOARD_RESULTS_SUCCESS =
    'FETCH_DASHBOARD_RESULTS_SUCCESS';
export const FETCH_DASHBOARD_COSTS_SUCCESS = 'FETCH_DASHBOARD_COSTS_SUCCESS';
export const FETCH_DASHBOARD_REPORT_SUCCESS = 'FETCH_DASHBOARD_REPORT_SUCCESS';
export const EVENT_STATUS_BREAKDOWN_LOADING = 'EVENT_STATUS_BREAKDOWN_LOADING';
export const EVENT_STATUS_BREAKDOWN_SUCCESS = 'EVENT_STATUS_BREAKDOWN_SUCCESS';
export const EVENT_STATUS_BREAKDOWN_DATA = 'EVENT_STATUS_BREAKDOWN_DATA';
export const TASKS_DUE_TOTAL = 'TASKS_DUE_TOTAL';
export const TASKS_DUE_LOADING = 'TASKS_DUE_LOADING';

//Calendar
export const SET_CALENDAR_VIEW = 'SET_CALENDAR_VIEW';
export const SET_CALENDAR_ACTIVE = 'SET_CALENDAR_ACTIVE';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const SET_FOCUS_DATE = 'SET_FOCUS_DATE';
export const TOGGLE_CALENDAR_FILTERS = 'TOGGLE_CALENDAR_FILTERS';
export const APPLY_CALENDAR_FILTERS = 'APPLY_CALENDAR_FILTERS';
export const FETCH_CALENDAR_SUCCESS = 'FETCH_CALENDAR_SUCCESS';
export const SET_EVENT_WINDOW_START = 'SET_EVENT_WINDOW_START';
export const SET_EVENT_WINDOW_END = 'SET_EVENT_WINDOW_END';
export const SET_FOCUS_DATE_DIRECT = 'SET_FOCUS_DATE_DIRECT';
export const CAL_LOADING = 'CAL_LOADING';
export const CAL_LOADING_SUCCESS = 'CAL_LOADING_SUCCESS';
export const RESET_CAL_EVENTS = 'RESET_CAL_EVENTS';
export const ONLOAD_CALENDAR_LOCATIONS = 'ONLOAD_CALENDAR_LOCATIONS';
export const UPDATE_CALENDAR_DISTRICT_SUCCESS =
    'UPDATE_CALENDAR_DISTRICT_SUCCESS';
export const UPDATE_CALENDAR_RS_SUCCESS = 'UPDATE_CALENDAR_RS_SUCCESS';
export const UPDATE_CALENDAR_RSS_OSS_SUCCESS =
    'UPDATE_CALENDAR_RSS_OSS_SUCCESS';

//Reporting
export const TOGGLE_MODAL_REPORTING = 'TOGGLE_MODAL_REPORTING';
export const REPORTING_LOADING = 'REPORTING_LOADING';
export const TOGGLE_MODAL_GENERATE_REPORTING =
    'TOGGLE_MODAL_GENERATE_REPORTING';
export const FETCH_REPORTING_ITEM = 'FETCH_REPORTING_ITEM';
export const TOGGLE_REPORTING_FILTERS = 'TOGGLE_REPORTING_FILTERS';
export const APPLY_REPORTING_FILTERS = 'APPLY_REPORTING_FILTERS';
export const FETCH_REPORTING_DATA_SUCCESS = 'FETCH_REPORTING_DATA_SUCCESS';
export const FILTER_BTN_ACTION = 'FILTER_BTN_ACTION';
export const UPDATE_REPORTING_DISTRICT_SUCCESS =
    'UPDATE_REPORTING_DISTRICT_SUCCESS';
export const UPDATE_REPORTING_RS_SUCCESS = 'UPDATE_REPORTING_RS_SUCCESS';
export const UPDATE_REPORTING_RSS_OSS_SUCCESS =
    'UPDATE_REPORTING_RSS_OSS_SUCCESS';

//Event
export const CREATE_EVENT = 'CREATE_EVENT';
export const SET_EVENT_STATUS = 'SET_EVENT_STATUS';
export const SET_EVENT_ID = 'SET_EVENT_ID';
export const SET_EVENT_NAME = 'SET_EVENT_NAME';
export const SET_EVENT_ACTIONS = 'SET_EVENT_ACTIONS';
export const SET_USER_IS_CREATOR = 'SET_USER_IS_CREATOR';
export const SET_CURRENT_REVIEWER_ID = 'SET_CURRENT_REVIEWER_ID';
export const SET_INVALID_TABS = 'SET_INVALID_TABS';
export const SET_EVENT_START_DATE = 'SET_EVENT_START_DATE';
export const SET_EVENT_TASKS = 'SET_EVENT_TASKS';
export const GET_EVENT_TASKS = 'GET_EVENT_TASKS';
export const ADD_EVENT_TASK = 'ADD_EVENT_TASK';
export const CREATE_EVENT_REPORT = 'CREATE_EVENT_REPORT';
export const UPDATE_FUNDED_DISTRICT_SUCCESS = 'UPDATE_FUNDED_DISTRICT_SUCCESS';
export const UPDATE_FUNDED_RS_SUCCESS = 'UPDATE_FUNDED_RS_SUCCESS';
export const UPDATE_FUNDED_RSS_SUCCESS = 'UPDATE_FUNDED_RSS_SUCCESS';
export const SET_REJECT_COMMENTS = 'SET_REJECT_COMMENTS';
export const SET_EVENT_SUCCESS_MESSAGE = 'SET_EVENT_SUCCESS_MESSAGE';
export const SET_EVENT_ERROR_MESSAGE = 'SET_EVENT_ERROR_MESSAGE';
export const SET_EVENT_REJECT_MODAL_ACTIVE = 'SET_EVENT_REJECT_MODAL_ACTIVE';
export const SET_EVENT_REQUEST_MODAL_ACTIVE = 'SET_EVENT_REQUEST_MODAL_ACTIVE';
export const SET_EVENT_APPROVE_MODAL_ACTIVE = 'SET_EVENT_APPROVE_MODAL_ACTIVE';
export const SET_AA_APPROVE_MODAL_ACTIVE = 'SET_AA_APPROVE_MODAL_ACTIVE';
export const SET_EVENT_USER_ACTION = 'SET_EVENT_USER_ACTION';
export const SET_EVENT_AFTER_ACTION_MOD = 'SET_EVENT_AFTER_ACTION_MOD';
export const SET_EVENT_APPROVERS = 'SET_EVENT_APPROVERS';
export const SET_AA_APPROVERS = 'SET_AA_APPROVERS';
export const SET_AA_NOTES = 'SET_AA_NOTES';
export const ADD_AA_NOTE = 'ADD_AA_NOTE';
export const SET_AA_STATUS = 'SET_AA_STATUS';
export const SET_AA_TASKS = 'SET_AA_TASKS';
export const SET_EVENT_SAVE_SUBMIT = 'SET_EVENT_SAVE_SUBMIT';
export const SET_EVENT_APPROVE_REJECT = 'SET_EVENT_APPROVE_REJECT';
export const SET_EVENT_FILES = 'SET_EVENT_FILES';
export const SET_PR_SAVE_SUBMIT = 'SET_PR_SAVE_SUBMIT';
export const SET_PR_ACCESSIBLE = 'SET_PR_ACCESSIBLE';
export const SET_PR_STATUS = 'SET_PR_STATUS';
export const ADD_VENDOR_ITEM = 'ADD_VENDOR_ITEM';
export const CLEAR_VENDOR_ITEMS = 'CLEAR_VENDOR_ITEMS';
export const STORE_PURCHASE_REQUEST = 'STORE_PURCHASE_REQUEST';
export const SET_PR_COMPLETE = 'SET_PR_COMPLETE';
export const SET_CONTRACT = 'SET_CONTRACT';
export const SET_PARENT_SEARCH = 'SET_PARENT_SEARCH';
export const SET_APPROVER_STATE = 'SET_APPROVER_STATE';
export const SET_PR_MODAL = 'SET_PR_MODAL';
export const SET_MCRC_UPLOADED_FILE = 'SET_MCRC_UPLOADED_FILE';
export const SET_DISTRICT_UPLOADED_FILE = 'SET_DISTRICT_UPLOADED_FILE';
export const SET_REGIONAL_UPLOADED_FILE = 'SET_REGIONAL_UPLOADED_FILE';
export const SET_ONSITE_ACTIVATIONS = 'SET_ONSITE_ACTIVATIONS';
export const SET_AA_RECOMMENDED = 'SET_AA_RECOMMENDED';
export const SET_EVENT_RECOMMENDED = 'SET_EVENT_RECOMMENDED';
export const SET_AA_REQUEST_MODAL = 'SET_AA_REQUEST_MODAL';
export const SET_AA_REQUEST_MESSAGE = 'SET_AA_REQUEST_MESSAGE';
export const SET_SELECTED_CATEGORIES = 'SET_SELECTED_CATEGORIES';
export const SET_SHOW_EVENT_RECOMMEND = 'SET_SHOW_EVENT_RECOMMEND';
export const SET_EVENT_END_DATE = 'SET_EVENT_END_DATE';
export const EVENT_LOADING = 'EVENT_LOADING';
export const EVENT_LOADING_SUCCESS = 'EVENT_LOADING_SUCCESS';
export const EVENT_ACTION_LOADING = 'EVENT_ACTION_LOADING';
export const EVENT_ACTION_SUCCESS = 'EVENT_ACTION_SUCCESS';
export const PR_LOADING = 'PR_LOADING';
export const PR_LOADING_SUCCESS = 'PR_LOADING_SUCCESS';
export const SET_VENDORS_DROPDOWN = 'SET_VENDORS_DROPDOWN';
export const UPDATE_ATTACHED_DOCUMENTS = 'UPDATE_ATTACHED_DOCUMENTS';
export const TOGGLE_MODAL_LEAD_COUNT = 'TOGGLE_MODAL_LEAD_COUNT';
export const LEAD_COUNT = 'LEAD_COUNT';
export const FORM_SAVED = 'FORM_SAVED';
export const SET_FORM_PRISTINE = 'SET_FORM_PRISTINE';
export const EVENT_GROUP_STATUS = 'EVENT_GROUP_STATUS';
export const REMOVE_DOCUMENT_SUCCESS = 'REMOVE_DOCUMENT_SUCCESS';

//Category
export const FETCH_CATEGORY = 'FETCH_CATEGORY';
export const FETCH_REPORTING_CATEGORY = 'FETCH_REPORTING_CATEGORY';

//Assigned Location
export const ASSIGNMENT_OPTIONS = 'ASSIGNMENT_OPTIONS';
export const ASSIGNEE_OPTIONS = 'ASSIGNEE_OPTIONS';
export const ASSIGNEE_LOADING = 'ASSIGNEE_LOADING';
export const ASSIGNEE_USERNAME_SUCCESS = 'ASSIGNEE_USERNAME_SUCCESS';
export const SHOW_HIDE_ASSIGNED_LOCATION = 'SHOW_HIDE_ASSIGNED_LOCATION';
export const HIDE_ASSIGNED_LOCATION = 'HIDE_ASSIGNED_LOCATION';

//Dev Login
export const DEV_ERROR_LOGIN_MESSAGE = 'DEV_ERROR_LOGIN_MESSAGE';

//Admin
export const FETCH_CURRENTLY_ASSIGNED_TO_SUCCESS =
    'FETCH_CURRENTLY_ASSIGNED_TO_SUCCESS';
export const COUNTER_SUCCESS = 'COUNTER_SUCCESS';
export const REMOVE_SUBMISSION_BANNER = 'REMOVE_SUBMISSION_BANNER';
export const SUBMISSION_REASSIGN_EVENTS_SUCCESS =
    'SUBMISSION_REASSIGN_EVENTS_SUCCESS';
export const FETCH_REASSIGNED_TO_SUCCESS = 'FETCH_REASSIGNED_TO_SUCCESS';
export const FETCH_CURRENTLY_ASSIGNED_TO_EVENTS_SUCCESS =
    'FETCH_CURRENTLY_ASSIGNED_TO_EVENTS_SUCCESS';
export const FETCH_CURRENTLY_ASSIGNED_TO_EVENTS_LOADING =
    'FETCH_CURRENTLY_ASSIGNED_TO_EVENTS_LOADING';
export const REASSIGN_SUBMIT_LOADING = 'REASSIGN_SUBMIT_LOADING';



// WEBPACK FOOTER //
// ./src/actions/action-types.js